import { Controller } from "@hotwired/stimulus";

/**
 * Poll Reload Controller (GR-2416)
 *
 * Refreshes the enclosing <turbo-frame> on an interval so a long-running
 * background job's status updates without a manual refresh. Scoped to the frame
 * (the "Recent Imports" list) rather than the whole page, so the upload form
 * outside the frame keeps any in-progress file selection.
 *
 * Rendered only while there is work in progress; once the reloaded frame no
 * longer contains this controller, Stimulus disconnects it and the interval
 * stops. Uses setInterval (not a self-rescheduling setTimeout) so a single
 * failed fetch doesn't silently end polling.
 */
export class PollReloadController extends Controller {
  static values = { interval: { type: Number, default: 6000 } };

  connect() {
    this.frame = this.element.closest("turbo-frame");
    this.timer = setInterval(() => this.refresh(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  refresh() {
    if (!this.frame) return;

    // First tick sets the src (which fetches); later ticks re-fetch the same
    // src via reload().
    if (this.frame.src) {
      this.frame.reload();
    } else {
      this.frame.src = window.location.href;
    }
  }
}
